// @noflow
import { bulbTypes, deviceTypes as dt } from '~/core/constants/devices';

import { consumerProperties } from '~/core/utils/recipes';
import { consumerPropertyTypes as cpt, notificationTypes } from '~/core/constants/recipes';
import { FormattedMessage } from 'react-intl';
import { identity } from 'lodash/fp';
import messages from './intl';
import moment from 'moment-timezone';
import * as React from 'react';
import styled from 'styled-components';
import TimeSpan from '~/components/widgets/timespan';

export const B = styled.span`font-weight: bold;`;

export const getWhenText = (formatMessage, producer) => {
    const message = {
        [true]: '',
        [producer.type === dt.MOTION_SENSOR]: messages.whenDetectsMotion,
        [producer.type === dt.CONTACT_SENSOR && producer.trigger === 'OPEN']: messages.whenContactIsOpened,
        [producer.type === dt.CONTACT_SENSOR && producer.trigger === 'CLOSED']: messages.whenContactIsClosed,
        [producer.type === dt.HIVE_BUTTON && producer.trigger === 'BUTTON_PRESSED']: messages.whenButtonIsPressed,
        [producer.type === dt.HIVE_BUTTON &&
        producer.trigger === 'BUTTON_DOUBLE_PRESSED']: messages.whenButtonIsDoublePressed,
        [producer.type === dt.HIVE_BUTTON &&
        producer.trigger === 'BUTTON_LONG_HOLD_PRESSED']: messages.whenButtonIsLongHoldPressed
    }[true];

    return (
        <FormattedMessage
            {...message}
            values={{
                deviceName: <B>{producer.name}</B>
            }}
        />
    );
};

export const getThenNotificationText = (formatMessage, notificationOptions) => {
    const { email, push, sms } = notificationTypes;
    const list = [
        notificationOptions.get(email, false) && formatMessage(messages[email]),
        notificationOptions.get(push, false) && formatMessage(messages[push]),
        notificationOptions.get(sms, false) && formatMessage(messages[sms])
    ].filter(identity);

    const text = list.length > 0 ? list.join(', ').replace(/,([^,]*)$/, ' &$1') : '...';
    return (
        <FormattedMessage
            {...messages.notifyMeBy}
            values={{
                list: <B>{text}</B>
            }}
        />
    );
};

export const getThenConsumerText = (formatMessage, consumer) => {
    const actionText = {
        [true]: () => '',
        [consumer.type === dt.ACTIVE_PLUG && consumer.state.getIn([0, 'value']) === 'ON']: () => (
            <FormattedMessage
                {...messages.turnPlugOn}
                values={{
                    deviceName: <B>{consumer.name}</B>
                }}
            />
        ),
        [consumer.type === dt.ACTIVE_PLUG && consumer.state.getIn([0, 'value']) === 'OFF']: () => (
            <FormattedMessage
                {...messages.turnPlugOff}
                values={{
                    deviceName: <B>{consumer.name}</B>
                }}
            />
        ),
        [bulbTypes.includes(consumer.type) && consumer.state.getIn([0, 'value']) === 'ON']: () => (
            <FormattedMessage
                {...messages.turnLightOn}
                values={{
                    deviceName: <B>{consumer.name}</B>
                }}
            />
        ),
        [bulbTypes.includes(consumer.type) && consumer.state.getIn([0, 'value']) === 'OFF']: () => (
            <FormattedMessage
                {...messages.turnLightOff}
                values={{
                    deviceName: <B>{consumer.name}</B>
                }}
            />
        ),
        [consumer.type === dt.HEATING]: () => {
            const mode = consumer.state.find(
                action => action.get('field') === consumerProperties[cpt.changeHeatingMode].field
            );
            if (mode.get('value') === 'OFF') {
                return (
                    <FormattedMessage
                        {...messages.turnHeatingOff}
                        values={{
                            deviceName: <B>{consumer.name}</B>
                        }}
                    />
                );
            }
            const target = consumer.state.find(
                action => action.get('field') === consumerProperties[cpt.changeHeatingTarget].field
            );
            if (mode.get('value') === 'HEAT') {
                if (!!target) {
                    return (
                        <FormattedMessage
                            {...messages.setHeatingToManual}
                            values={{
                                deviceName: <B>{consumer.name}</B>,
                                degrees: target.get('value')
                            }}
                        />
                    );
                } else {
                    return (
                        <FormattedMessage
                            {...messages.setHeatingToSchedule}
                            values={{
                                deviceName: <B>{consumer.name}</B>
                            }}
                        />
                    );
                }
            }
            if (mode.get('value') === 'BOOST') {
                const boost = consumer.state.find(
                    action => action.get('field') === consumerProperties[cpt.changeHeatingBoost].field
                );
                return (
                    <FormattedMessage
                        {...messages.boostHeating}
                        values={{
                            deviceName: <B>{consumer.name}</B>,
                            degrees: target.get('value'),
                            duration: <TimeSpan value={moment.duration(boost.get('value'), 'minutes')} />
                        }}
                    />
                );
            }

            return 'Heating consumer';
        }
    }[true]();

    let duration;
    if (consumer.duration) {
        duration = (
            <FormattedMessage
                {...messages.for}
                values={{
                    duration: <TimeSpan value={moment.duration(consumer.duration, 'seconds')} />
                }}
            />
        );
    }

    return (
        <span>
            {actionText} {duration}
        </span>
    );
};



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/common.js